// extracted by mini-css-extract-plugin
export var divider = "_m1-0";
export var systemMessage = "_m1-1";